import { useEffect, useState } from 'react';

import FactCheckIcon from '@mui/icons-material/FactCheck';

import LocalShippingIcon from '@mui/icons-material/LocalShipping';

import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

import RequestQuoteIcon from '@mui/icons-material/RequestQuote';

import { procurementApi, type ProcurementDashboardSummary } from '@/api/procurement.api';

import { StatCard } from '@/components/ui/StatCard';

import { DashboardLayout } from '@/shared/layouts/DashboardLayout';

import { KpiGrid } from '@/components/ui/KpiGrid';

import { QuickActionGrid } from '@/components/ui/QuickActionGrid';

import { PageSection } from '@/components/ui/PageSection';

import { Callout } from '@/components/ui/Callout';

import { DashboardSkeleton } from '@/components/ui/Skeleton';

import { showApiError } from '@/utils/apiError';



const LINKS = [

  { to: '/procurement/purchase-requests', label: 'Purchase requests', description: 'Internal requisitions with dynamic approval' },

  { to: '/procurement/purchase-orders', label: 'Purchase orders', description: 'Orders placed — does not add stock' },

  { to: '/procurement/goods-receipts', label: 'Goods receipts (GRN)', description: 'Receive goods — posts inventory inward' },

  { to: '/procurement/rfqs', label: 'RFQs & quotations', description: 'Supplier quotes and comparison' },

  { to: '/org/suppliers', label: 'Suppliers', description: 'Supplier master data' },

  { to: '/procurement/approvals', label: 'Pending approvals', description: 'Documents awaiting your sign-off' },

  { to: '/procurement/setup', label: 'Approval workflows', description: 'Amount-based dynamic approvers' },

  { to: '/procurement/reports', label: 'Reports', description: 'Export PO, RFQ, GRN, spend reports' },

  { to: '/procurement/contracts', label: 'Contracts', description: 'Supplier agreements and auto-reorder' },

  { to: '/procurement/catalogs', label: 'Supplier catalogs', description: 'Published supplier item catalogs' },

  { to: '/vendor-portal/login', label: 'Vendor portal', description: 'Supplier quote and invoice submission' },

];



export function ProcurementDashboardPage() {

  const [stats, setStats] = useState<ProcurementDashboardSummary | null>(null);

  const [loading, setLoading] = useState(true);



  useEffect(() => {
    procurementApi

      .dashboardSummary()

      .then(setStats)

      .catch((err) => showApiError(err, 'Failed to load procurement dashboard'))

      .finally(() => setLoading(false));

  }, []);



  if (loading) {

    return (

      <DashboardLayout

        moduleLabel="Procurement"

        title="Procurement Dashboard"

        description="Purchase lifecycle KPIs and operational health"

      >

        <DashboardSkeleton kpiCount={4} />

      </DashboardLayout>

    );

  }



  return (

    <DashboardLayout

      moduleLabel="Procurement"

      title="Procurement Dashboard"

      description="Purchase lifecycle KPIs and operational health. Reports and setup are separated by design."

    >

      <KpiGrid columns={4}>

        <StatCard title="Pending approvals" value={stats?.pendingApprovals ?? '—'} icon={<FactCheckIcon />} />

        <StatCard title="Open PRs" value={stats?.openPurchaseRequests ?? '—'} icon={<RequestQuoteIcon />} />

        <StatCard title="Open POs" value={stats?.openPurchaseOrders ?? '—'} icon={<ReceiptLongIcon />} />

        <StatCard title="Pending GRNs" value={stats?.pendingGrns ?? '—'} icon={<LocalShippingIcon />} />

      </KpiGrid>



      <PageSection title="Quick actions">

        <QuickActionGrid items={LINKS} columns={3} />

      </PageSection>



      <Callout variant="warning" title="Stock receipt">

        Legacy <code className="rounded bg-warning-100 px-1 py-0.5 text-xs">/v1/purchases</code> is retired — receive stock only via GRN post under Goods receipts.

      </Callout>

    </DashboardLayout>

  );

}


